import React, {useState, useEffect} from 'react';
import {Link, Redirect} from 'react-router-dom';
import {register} from '../redux/user/userActions';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../components/Loading';

const RegisterScreen = () => {
    const [formData, setFormData] = useState({
        name : '',
        email: '',
        password: '',
      })
    
    const dispatch = useDispatch();
    const userRegister = useSelector(state => state.userRegister);
    const {error, loading, userInfo} = userRegister;

    const { name, email, password } = formData

    const [redirect, setRedirect] = useState(false);

    useEffect(() => {
        if(localStorage.getItem('userInfo')){
            setRedirect(true)
        }
    },[userInfo])

    const onChange = (e) => {
        setFormData((prevState) => ({
          ...prevState,
          [e.target.id]: e.target.value,
        }))
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        dispatch(register(formData))
        setFormData({name : '',email : '', password : ''})
    }

    if(loading) {
        return <Loading/>
    }

    if(redirect){
        return <Redirect to="/"/>
    }

    return (
        <div className='pageContainer'>
            <header className='pageHeader'>
                <p>Welcome!</p>
            </header>

            <div className="pageBody">
                <form>
                    <input
                        type='text'
                        className='nameInput'
                        placeholder='Name'
                        id='name'
                        value={name}
                        onChange={onChange}
                    />

                    <input
                        type='email'
                        className='emailInput'
                        placeholder='Email'
                        id='email'
                        value={email}
                        onChange={onChange}
                    />

                    <input
                        type='password'
                        className='passwordInput'
                        placeholder='Password'
                        id='password'
                        value={password}
                        onChange={onChange}
                    />
                </form>
                
                {error && <p style={{color : 'red'}}>{error}</p>}

                <div className="textLink">
                    Already a User ?
                    <Link className='nav loginLink' to='/login'>
                        Login
                    </Link>
                </div>

                <button type='submit' onClick={onSubmit} className='btn signUpButton'>
                    SignUp
                </button>
            </div>

        </div>
    )
};

export default RegisterScreen;
